module.exports = __webpack_public_path__ + "static/g1-a8d8cff66a633213ac65904e246a1736.png";